import { useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import Nav from './nav';
import Main from './main';
import Header from './header';
import { NAV } from './config-layout';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);

  return (
    <>
      <Header onOpenNav={() => setOpenNav(true)} />

      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          bgcolor: 'transparent',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />

        <Main
          sx={{
            px: { xs: 1.5, sm: 2, lg: 2.5 },
            width: { lg: `calc(100% - ${NAV.WIDTH}px)` },
            maxWidth: '100%',
            overflowX: 'hidden',
          }}
        >
          {children}
        </Main>
      </Box>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
